import { call, put, takeLatest } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import {
  deleteScheduledMessagesByID,
  deleteAllScheduledMessages,
  getScheduledMessages,
} from 'api/ScheduledMessagesAPI';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { getErrorResponse } from 'utils/xhr';
import {
  deleteScheduledMessagesResponse,
  deleteScheduledMessagesError,
  deleteAllScheduledMessagesResponse,
  deleteAllScheduledMessagesError,
  fetchScheduledMessagesResponse,
  fetchScheduledMessagesError,
} from './actions';
import { DeleteSagaRequest } from './types';
import * as t from './actionTypes'; // see note accompanying `addToRootSaga` for import syntax variation

/**
 * Retrieve the scheduled messages from the API and update the Redux store.
 */
export function* fetchScheduledMessagesSaga() {
  try {
    const { data } = yield call(getScheduledMessages);
    yield put(fetchScheduledMessagesResponse(data));
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(fetchScheduledMessagesError(err));
    const message = 'Please try again later. If the problem persists, contact your CSM.';
    yield put(addNegativeToast(message));
  }
}

export function* deleteScheduledMessagesSaga(data: DeleteSagaRequest) {
  const { payload } = data;
  try {
    yield call(deleteScheduledMessagesByID, payload);
    yield put(deleteScheduledMessagesResponse(payload));
    yield put(addPositiveToast('Success!'));
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(deleteScheduledMessagesError(err));
    const message = 'Please try again later. If the problem persists, contact your CSM.';
    yield put(addNegativeToast(message));
  }
}

export function* deleteAllScheduledMessagesSaga(data: DeleteSagaRequest) {
  const { payload } = data;

  try {
    // Deleting all the messages doesn't require ids in the payload
    yield call(deleteAllScheduledMessages, payload);
    yield put(deleteAllScheduledMessagesResponse(payload));
    yield put(addPositiveToast('Success!'));
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(deleteAllScheduledMessagesError(err));
    const message = 'Please try again later. If the problem persists, contact your CSM.';
    yield put(addNegativeToast(message));
  }
}

addToRootSaga([
  takeLatest([t.FETCH_SCHEDULED_MESSAGES_REQUEST], fetchScheduledMessagesSaga),
  takeLatest([t.DELETE_SCHEDULED_MESSAGES_REQUEST], deleteScheduledMessagesSaga),
  takeLatest([t.DELETE_ALL_SCHEDULED_MESSAGES_REQUEST], deleteAllScheduledMessagesSaga),
]);
